module.exports = __webpack_public_path__ + "img/photo_camera_white_24dp.797505ff.svg";